import storage from "@common/lib/storage";

type PersistState = {
  email: string;
  ticketId: string;
  scheduleId: string;
};
export const persist = {
  get: (portalId: string, userId: number | null): PersistState | null =>
    storage.get(`${portalId}-${userId ?? "anonymous"}-mtd`),
  set: (portalId: string, userId: number | null, state: PersistState) =>
    storage.set(`${portalId}-${userId ?? "anonymous"}-mtd`, state)
};
